import React, { FC } from 'react'
import useModals from 'src/Hooks/useModals'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ButtonWithLoading } from '@e3dc-react/shell/Elements/Buttons'

interface CompanyDeleteButtonProps {
  companyName: string
  handleDeleteCompany: () => void
  isLoading: boolean
  isDisabled?: boolean
  fullWidth?: boolean
}

const CompanyDeleteButton: FC<CompanyDeleteButtonProps> = ({ isDisabled, companyName, handleDeleteCompany, isLoading, fullWidth }) => {
  const { t } = useCustomTranslation()
  const { openConfirmationModal } = useModals()

  const onConfirm = (onClose: () => void): void => {
    handleDeleteCompany()
    onClose()
  }

  return (
    <ButtonWithLoading
      variant="outlined"
      size="large"
      color="primary"
      fullWidth={fullWidth}
      disabled={isDisabled}
      isLoading={isLoading}
      label={t('service-dashboard.company.delete-company.title')}
      onClick={() => {
        openConfirmationModal({
          buttonText: [t('common.cancel'), t('common.delete')],
          onConfirm,
          text: t('service-dashboard.company.delete-company.text', { name: companyName }),
          title: t('service-dashboard.company.delete-company.title'),
        })
      }}
    />
  )
}

export default CompanyDeleteButton
